import { Link } from "react-router-dom";
import styled from 'styled-components'
import { sharedStyle } from "./styles";


// Link React router component styled
export const LinkButtom = styled(Link)`
${sharedStyle}



`